import { useCallback, useContext, useState } from "react";
import { Button, Tooltip } from "@mui/material";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import { useMap } from "@mapcomponents/react-maplibre";
import ErrorMessageDisplay from "./ErrorMessageDisplay";
import useGeolocation from "../hooks/useGeolocation";
import { MapPointContext } from "../context/MapPointContext";

const GPS_ZOOM_LEVEL = 16;

export default function GpsButton(props) {
    const mapHook = useMap({ mapId: props.mapId || "map_1" });
    const { getCurrentPosition, locationErrorMessage } = useGeolocation();
    const mapPointContext = useContext(MapPointContext);
    const [errorMessage, setErrorMessage] = useState("");

    const getLocationSuccess = useCallback(
        (location) => {
            const targetCoordinates = [
                location.coords.longitude,
                location.coords.latitude,
            ];

            mapHook.map?.map.flyTo({
                center: targetCoordinates,
                zoom: GPS_ZOOM_LEVEL,
            });
            
            mapPointContext.setActivePoint(targetCoordinates, "gps");
            setErrorMessage("");
        },
        [mapHook.map, mapPointContext],
    );

    const getLocationError = useCallback(() => {
        setErrorMessage(locationErrorMessage);
    }, [locationErrorMessage]);

    const centerCurrentLocation = useCallback(() => {
        getCurrentPosition(getLocationSuccess, getLocationError);
    }, [getCurrentPosition, getLocationSuccess, getLocationError]);

    return (
        <>
            <Tooltip title={"Ihre Standort anrufen"}>
                <Button
                    variant="navtools"
                    onClick={centerCurrentLocation}
                    sx={(theme) => ({
                        color: theme.palette.navigation.buttonColor,
                    })}
                >
                    <MyLocationIcon />
                </Button>
            </Tooltip>
            {errorMessage && (
                <ErrorMessageDisplay
                    error={errorMessage}
                    setMessage={setErrorMessage}
                />
            )}
        </>
    );
}
